import app from 'flarum/common/app';
app.initializers.add('huseyinfiliz/custom-profile-page', () => {
  // Common initialization - currently empty
  // Models are registered in forum/admin initializers
});